/**
 * Compare two strings with a safe comparator that handles null, undefined
 * and empty/whitespace strings by pushing those entries to the end of the sorted list
 * and sorting non-empty strings alphabetically
 * @param a - First string
 * @param b - Second string
 * @returns Comparison result: -1 if a < b, 1 if a > b, 0 if equal
 */
export function compareStringsWithEmptyLast(a?: string | null, b?: string | null): number {
  const normalizedA = a?.trim() ?? '';
  const normalizedB = b?.trim() ?? '';

  const isAEmpty = normalizedA.length === 0;
  const isBEmpty = normalizedB.length === 0;

  if (isAEmpty && isBEmpty) {
    return 0;
  }
  if (isAEmpty) {
    return 1;
  }
  if (isBEmpty) {
    return -1;
  }

  return normalizedA.localeCompare(normalizedB, undefined, { sensitivity: 'base' });
}
